import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { ArrowUp } from "lucide-react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import EditorialMarquee from "../components/EditorialMarquee";
import Services from "../components/Services";
import Products from "../components/Products";
import TechGrid from "../components/TechGrid";
import WhyChoose from "../components/WhyChoose";
import Process from "../components/Process";
import Work from "../components/Work";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  const location = useLocation();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has("thank-you")) {
      toast.success("Thank you! Your consultation request has been received.");
      window.history.replaceState({}, document.title, window.location.pathname);
    }
    if (params.has("newsletter-thanks")) {
      toast.success("Thanks for subscribing! You'll hear from us soon.");
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [location.search]);

  useEffect(() => {
    const handleScroll = () => setShowScrollTop(window.scrollY > 320);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="App relative">
      <Navbar />
      <main>
        <Hero />
        {/* <Stats /> */}
        <EditorialMarquee />
        <Services />
        <Products />
        <TechGrid />
        <WhyChoose />
        <Process />
        <Work />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      {showScrollTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Scroll to top"
          className="fixed bottom-6 right-6 z-50 grid place-items-center h-12 w-12 rounded-full bg-brand text-[#05050A] shadow-2xl hover:scale-105 transition-transform"
        >
          <ArrowUp size={20} />
        </button>
      )}
    </div>
  );
}
